import { EPDFieldNameEnum } from "api-client";

export const CONCORE_EPD_FILTER_CATEGORIES = [
  {
    id: EPDFieldNameEnum.Database,
    name: "Data source",
    name_de: "Datenquelle",
    value: EPDFieldNameEnum.Database,
    hasChildren: true,
  },
  {
    id: EPDFieldNameEnum.ReferenceUnit,
    name: "Reference Unit",
    name_de: "Referenzeinheit",
    value: EPDFieldNameEnum.ReferenceUnit,
    hasChildren: true,
  },
  {
    id: EPDFieldNameEnum.ConformityName,
    name: "Conformity",
    name_de: "Konformität",
    value: EPDFieldNameEnum.ConformityName,
    hasChildren: true,
  },
  {
    id: EPDFieldNameEnum.DataType,
    name: "EPD Type",
    name_de: "EPD Typ",
    value: EPDFieldNameEnum.DataType,
    hasChildren: true,
  },
  {
    id: "creator",
    name: "Added by",
    name_de: "Hinzugefügt durch",
    value: "creator",
    hasChildren: true,
  },
];
